import { InvoiceStatus, InvoiceType } from '@rematter/frontend-lib-api-client';

import { createQueryHook } from '~/shared/providers/api';

export const useInvoiceStatusCountsQuery = createQueryHook(
  'finance.invoiceStatusCounts',
  (params?: {
    types?: InvoiceType[];
    statuses?: InvoiceStatus[];
    accountIDs?: string[];
    searchTerm?: string;
  }) => ({
    invoiceStatusCounts: {
      __args: {
        filter: params
          ? {
              types: params.types,
              statuses: params.statuses,
              accountIDs: params.accountIDs,
              searchTerm: params.searchTerm,
            }
          : undefined,
      },
      proForma: true,
      pending: true,
      paid: true,
      voided: true,
    },
  }),
);
